/**
 * Retrieve product options
 *
 * @param {HTMLElement} productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
const getProductOptions = function(productContainer) {
  if (!productContainer) return [];
  const options = [...productContainer.querySelectorAll('[js-hook-product-option]')].map(option => {
    const elOption = option.querySelector('.options-select');
    const urlValue = elOption.value;
    const selectedValueId = elOption.querySelector(`option[value="${urlValue}]`).dataset.valueId;

    return {
      optionId: option.dataset.optionId,
      selectedValueId
    };
  });

  return options.length ? JSON.stringify(options) : [];
};

export default getProductOptions;
